// React
import React from 'react';
import PropTypes from 'prop-types';

// Components
import CardSpacer from '../../../../components/CardSpacer/CardSpacer';
import JobSummaryCard from './JobSummaryCard/JobSummaryCard';
import AssignmentIcon from '@material-ui/icons/AssignmentOutlined';

// Helpers
import { find } from 'lodash-es';

// Styles
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function Requests(props) {
  const { classes, requests, spaces, amenities, issues, causes, handleRemove } =
    props;

  return (
    <div
      className={requests.length > 0 ? classes.root : classes.rootNoRequests}
    >
      {requests.map((request, i) => {
        return (
          <React.Fragment key={i}>
            <JobSummaryCard
              icon={<AssignmentIcon />}
              data={{
                jobs: {
                  [find(spaces, ['id', request.where]).name]: [
                    `${
                      find(amenities[request.where], ['id', request.what]).name
                    } - ` +
                      find(issues[request.what], ['id', request.issue]).name,
                  ],
                },
                comments: request.jobComments,
                causedBy: find(causes, ['id', request.why]).name,
              }}
              contactAction={() => {}}
              secondaryAction={(e) => {
                handleRemove(i, e);
              }}
              jobNumber={`${i + 1}`}
            />
            {requests.length - 1 !== i ? <CardSpacer /> : null}
          </React.Fragment>
        );
      })}
    </div>
  );
}

Requests.propTypes = {
  classes: PropTypes.object.isRequired,
  requests: PropTypes.arrayOf(
    PropTypes.shape({
      where: PropTypes.string.isRequired,
      what: PropTypes.string.isRequired,
      issue: PropTypes.string.isRequired,
      why: PropTypes.string.isRequired,
    })
  ).isRequired,
  spaces: PropTypes.array.isRequired,
  amenities: PropTypes.object.isRequired,
  issues: PropTypes.object.isRequired,
  causes: PropTypes.array.isRequired,
  handleRemove: PropTypes.func.isRequired,
};

Requests.defaultProps = {};

export default withStyles(styles)(Requests);
